export default "__VITE_ASSET__B6ePUW7C__"